import React from 'react';
import { object, string, ref } from 'yup';
import omit from 'lodash/omit';

import { cloneDeep, isNaN } from 'lodash';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import { rolesCheck } from '~/commons/helpers';
import FormResource from './FormResource.jsx';

const defaults = {
  active: true,
  superAdmin: false,
  email: '',
  username: '',
  name: {
    full: {
      en: '',
    },
  },
  password: '',
  confirmPassword: '',
  orgIds: '',
  roles: ['admin'],
};

const password = string().matches(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=[a-zA-Z0-9!@#$^*]*$)(?=.{8,20}$)/,
  'Password must contain 8-20 characters, one uppercase, one lowercase, one number',
);

const schema = (admin) => object({
  username: string().required(),
  ...(!admin
    ? { password: password.required() }
    : { password }
  ),
  email: string().email(),
  confirmPassword: string().when('password', {
    is: (p) => p,
    then: (s) => s.required().oneOf([ref('password')], 'Password does not match'),
  }),
  orgIds: string().matches(/^(?:\d+,?)+$/, 'Invalid Organization ID Format'),
});

const FormAdmin = ({ admin }) => (
  <FormResource
    {...{
      defaults,
      schema: schema(admin),
      stored: admin ? {
        ...admin,
        orgIds: admin.orgIds.join(','),
        superAdmin: (admin.roles || []).includes('superAdmin'),
      } : undefined,
      api: '/api/core/users/admins',
      onSubmit: (v) => {
        const data = cloneDeep(omit(v, !v.password ? 'password' : null));

        const set = new Set(data.roles);
        if (data.superAdmin && !set.has('superAdmin')) set.add('superAdmin');
        if (!data.superAdmin && set.has('superAdmin')) set.delete('superAdmin');
        data.roles = [...set];

        data.orgIds = [
          ...new Set(
            data.orgIds
              .split(/,\s?/)
              .map((x) => parseInt(x, 10))
              .filter((x) => !isNaN(x)),
          ),
        ];

        return data;
      },
    }}>
    <div className="row">
      <div className="col">
        <div className="form-group">
          <label>Active</label>
          <FormCheckGroup name="active" type="checkbox" label="" asSwitch />
        </div>
      </div>
      <div className="col">
        {rolesCheck('superAdmin') && (
          <div className="form-group">
            <label>Super Admin</label>
            <FormCheckGroup
              name="superAdmin"
              type="checkbox"
              label=""
              asSwitch
            />
          </div>
        )}
      </div>
    </div>

    <div className="row">
      <div className="col">
        <FormGroup name="username" autoComplete='new-password' />
      </div>
      <div className="col">
        <FormGroup name="name.full.en" label="Name (English)" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="email" />
      </div>
      <div className="col">
        <FormGroup
          name="orgIds"
          label="Organization ID (Comma separated)"
          disabled={!rolesCheck('superAdmin')}
        />
      </div>
    </div>

    <div className="row">
      <div className="col">
        <FormGroup
          name="password"
          type="password"
          autoComplete="new-password"
          placeholder="Leave this blank to keep the stored password"
        />
      </div>
      <div className="col">
        <FormGroup
          name="confirmPassword"
          type="password"
          placeholder="Leave this blank to keep the stored password"
        />
      </div>
    </div>
  </FormResource>
);

export default FormAdmin;
